import * as React from "react"

/** Split a Rete title that uses `Name [[unit]]` into the name and the unit token. */
export function parseUnitTitle(title: string): { name: string; units?: string } {
  const [name, units] = title.split(/(?=\[\[)/).map(s => s.trim())
  return { name, units }
}

/** Same unit badge used on node sockets (`[[km²]]`, `[[MW]]`, `[[t/ha]]`, …). */
export function UnitBadge({ units }: { units?: string }) {
  if (!units) return null
  const density = units.includes("/")
  return (
    <span
      className="ml-2 badge badge-info text-secondary"
      style={{
        fontSize: ".7rem",
        fontWeight: "normal",
        backgroundColor: density ? "rgba(0, 104, 83, 0.5)" : "rgba(0, 72, 14, 0.5)",
      }}
    >
      {units.replace(/[\[\]]/g, "")}
    </span>
  )
}

export function TitledWithUnit({ title }: { title: string }) {
  const { name, units } = parseUnitTitle(title)
  return (
    <>
      {name}
      <UnitBadge units={units} />
    </>
  )
}
